import React, { useState, useEffect } from 'react';
import api from '../api';
import config from '../config';

// Module-level guard: ensures only one login redirect happens per page load
// even if multiple ProtectedRoute instances mount simultaneously.
let loginRedirectInProgress = false;

function redirectToLogin() {
  if (loginRedirectInProgress) {
    return;
  }
  loginRedirectInProgress = true;
  const returnUrl = encodeURIComponent(window.location.href);
  window.location.href = `${config.apiUrl}/ttauth/v1/cookie/login-redirect?returnUrl=${returnUrl}`;
}

function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        // The __ttauth cookie is sent automatically (withCredentials: true in api.js).
        // A 200 response means the cookie is valid; 401 triggers api.js interceptor redirect.
        await api.get('/api/user');
        setIsAuthenticated(true);
      } catch (error) {
        // Non-401 errors (network, 500, etc.) — show error state rather than redirect
        if (error.response?.status !== 401) {
          console.error('[PROTECTED ROUTE] ❌ Auth check failed:', error.message);
        }
        // 401 is handled by api.js interceptor (redirects to tt-auth)
        redirectToLogin();
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <h2 style={{ color: 'white' }}>Loading...</h2>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <h2>Redirecting to login...</h2>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
